import { render } from "./formValidation.vue?vue&type=template&id=13044380"
import script from "./formValidation.vue?vue&type=script&lang=js"
export * from "./formValidation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__